import { useThemeColor } from 'src/editor/shared/hooks/use-theme-color'
import { BackgroundColorEntityInterface } from 'src/shared/schemas/background-color.schema'
import { ColorEntityInterface } from 'src/shared/schemas/color.schema'
import { getCalculatedProperty } from 'src/shared/utils/get-calculated-property'

export interface UseCalculateFieldsThemeColorsProps
  extends ColorEntityInterface,
    BackgroundColorEntityInterface {}

export const useCalculateFieldsThemeColors = ({
  color,
  mobileColor,
  backgroundColor,
  mobileBackgroundColor,
}: UseCalculateFieldsThemeColorsProps) => {
  const { formFields } = useThemeColor()

  const formFieldBackgroundColor = formFields?.formFieldBackgroundColor
  const formFieldTextColor = formFields?.formFieldTextColor

  return {
    calculatedColor: getCalculatedProperty({
      desktopProperty: color,
      mobileProperty: mobileColor,
      globalDesktopProperty: formFieldTextColor,
    }),
    calculatedBackgroundColor: getCalculatedProperty({
      desktopProperty: backgroundColor,
      mobileProperty: mobileBackgroundColor,
      globalDesktopProperty: formFieldBackgroundColor,
    }),
  }
}
